module.exports = __webpack_public_path__ + "static/media/commissions4.04ff55a7.png";